import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface IMaintenanceStore {
  /** Window key (startsAt) of the last maintenance whose pre-alert was already shown. */
  lastAlertedWindowKey: string | null;
  markAlertShown: (windowKey: string) => void;
}

const useMaintenanceStore = create<IMaintenanceStore>()(
  persist(
    (set) => ({
      lastAlertedWindowKey: null,
      markAlertShown: (windowKey: string) => set({ lastAlertedWindowKey: windowKey }),
    }),
    {
      name: "meridian-maintenance",
    }
  )
);

export default useMaintenanceStore;

export const getLastAlertedWindowKey = () => useMaintenanceStore.getState().lastAlertedWindowKey;
